
import { defineComponent } from 'vue'
import { formatTimeString } from '@/services/agenda'
import AgendaSessionItem from '@/components/Agenda/AgendaSessionItem.vue'

export default defineComponent({
  name: 'AgendaList',
  components: {
    AgendaSessionItem
  },
  props: {
    list: {
      type: Object,
      required: true
    }
  },
  setup () {
    return {
      formatTimeString
    }
  }
})
